import { mustBeObjectWithFields, mustBeString, Validator } from "@me8eon/validate";
import { CryptoMetadata, CryptoMetadataAndSecret, WrappedKey } from "@enterprise_search/storage_crypto";
import { HasSecret } from "./crypto.client";

export const mustBeWrappedKey: Validator<WrappedKey> = mustBeObjectWithFields({
    iv: mustBeString,
    wrappedKey: mustBeString,
});
export const mustBeCryptoMetadata: Validator<CryptoMetadata> = mustBeObjectWithFields<CryptoMetadata>({
    iv: mustBeString,
    salt: mustBeString,
    algorithm: mustBeString,
    keyVersion: mustBeString,
    globalFingerprint: mustBeString,
    user: mustBeWrappedKey,
    admin: mustBeWrappedKey,
});
export const mustBeCryptoMetaDataAndSecret: Validator<CryptoMetadataAndSecret> = mustBeObjectWithFields<CryptoMetadataAndSecret>({
    metadata: mustBeCryptoMetadata,
    secret: mustBeString,
});
export const mustBeHasSecret: Validator<HasSecret> = mustBeObjectWithFields({ secret: mustBeString });